import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats a raw numeric value for goal-detail display.
 *
 * Usage:
 *   {{ goal.currentValue | formatValue: goal.recommendedType }}
 *
 * recommendedType values from GoalDictionary:
 *   "$" → currency, e.g. $234,567.00 / -$12,345.00
 *   "%" → percent, e.g. 85.3%
 *   "#" → locale number, e.g. 1,234 / 45.2
 *   ""  → plain number, e.g. 1234 / 45.2
 */
@Pipe({ name: 'formatValue', standalone: false })
export class FormatValuePipe implements PipeTransform {

  transform(value: number | string | null | undefined, type?: string): string {
    if (value == null) {
      return '—';
    }

    let num: number;
    if (typeof value === 'number') {
      num = value;
    } else {
      const cleaned = value.replace(/,/g, '');
      num = Number(cleaned);
    }

    if (isNaN(num)) {
      return String(value);
    }

    const t = (type ?? '').trim();

    if (t === '$') {
      if (num < 0) {
        return '-$' + Math.abs(num).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
      return '$' + num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

    if (t === '%') {
      return num.toLocaleString('en-US',{
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }) + '%';
    }

    if (t === '#') {
      return num.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    }

    // plain number
    return num.toLocaleString('en-US');
  }
}
